'use strict';

// d3 packages expose named exports under webpack; mhs-d3-core expected .default.*
function loadD3Module(mod) {
  if (mod && (mod.extent || mod.scaleLinear || mod.axisLeft || mod.select)) {
    return mod;
  }
  if (mod && mod.default) {
    return mod.default;
  }
  return mod;
}

exports.d3Array = loadD3Module(require('d3-array'));
exports.d3Scale = loadD3Module(require('d3-scale'));
exports.d3Axis = loadD3Module(require('d3-axis'));
exports.d3Selection = loadD3Module(require('d3-selection'));
